import { useState } from 'react'
import AddIcon from '@mui/icons-material/Add'

type ItemsListType = {
  listItems: Array<string>
  limitToShow: number
}

const ExpandableItemsList = ({ listItems, limitToShow }: ItemsListType) => {
  const [showMoreLines, setShowMoreLines] = useState<boolean>(false)

  return (
    <div>
      {listItems.slice(0, limitToShow).map((item) => {
        return (
          <li className='list-none' key={item}>
            {item}
          </li>
        )
      })}
      {showMoreLines &&
        listItems.slice(limitToShow).map((item) => {
          return (
            <li className='list-none' key={item}>
              {item}
            </li>
          )
        })}
      {listItems.length > limitToShow && (
        <div className='cursor-pointer text-sm font-medium text-lighthouseBlue'>
          <button
            className='mt-2'
            onClick={() => setShowMoreLines(!showMoreLines)}
          >
            <AddIcon className='mb-1 mr-1' sx={{ fontSize: '1.125rem' }} />
            <span>
              {!showMoreLines
                ? `Show ${listItems.length - limitToShow} more`
                : `Show Less`}
            </span>
          </button>
        </div>
      )}
    </div>
  )
}

export default ExpandableItemsList
